module.exports = __webpack_public_path__ + "img/prNHlogo.d76e42ad.png";